import { atom } from 'jotai';

export const fantasyGameUrlAtom = atom<string>('');

// 是否在fantasy Tab页
export const isFantasyActiveAtom = atom<boolean>(false);

// 是否在fantasy游戏中
export const isFantasyInGameAtom = atom<boolean>(false);